module.exports = __webpack_public_path__ + "static/media/on_connect_switch_Fr_pages.897b969b.pdf";